import { Grid } from '@mui/material';
import React from 'react';
import Color from './shared/Color';
import Slider from './shared/Slider';
import Switch from './shared/Switch';
import { UpdateFn } from './types';

type Props = {
	color: string;
	updateColor: UpdateFn;
	backgroundColor: string;
	updateBackgroundColor: UpdateFn;
	labelColor: string;
	updateLabelColor: UpdateFn;
	placeholderColor: string;
	updatePlaceholderColor: UpdateFn;
	borderRadius: string;
	updateBorderRadius: UpdateFn;
	borderOpacity: boolean;
	updateBorderOpacity: (value: string | undefined) => void;
};

const Inputs = ({
	color,
	updateColor,
	backgroundColor,
	updateBackgroundColor,
	labelColor,
	updateLabelColor,
	placeholderColor,
	updatePlaceholderColor,
	borderRadius,
	updateBorderRadius,
	borderOpacity,
	updateBorderOpacity
}: Props) => (
	<Grid container spacing={2}>
		<Color
			label={intl.tr('styleEditor.inputs.background.color')}
			hex={backgroundColor}
			onChange={updateBackgroundColor}
		/>
		<Color
			label={intl.tr('styleEditor.inputs.label.color')}
			hex={labelColor}
			onChange={updateLabelColor}
			disableAlpha
		/>
		<Color
			label={intl.tr('styleEditor.inputs.value.color')}
			hex={color}
			onChange={updateColor}
			disableAlpha
		/>
		<Color
			label={intl.tr('styleEditor.inputs.placeholder.color')}
			hex={placeholderColor}
			onChange={updatePlaceholderColor}
			disableAlpha
		/>
		<Switch
			data-testid="input-border"
			label={intl.tr('styleEditor.inputs.border')}
			checked={borderOpacity}
			onChange={(isBorder) => {
				updateBorderOpacity(isBorder ? undefined : '0');
			}}
		/>
		<Slider
			data-testid="input-radius"
			label={intl.tr('styleEditor.inputs.radius')}
			value={borderRadius}
			onChange={updateBorderRadius}
		/>
	</Grid>
);

export default Inputs;
